<div class="ddc-table-div-container-noscroll">
  <table mat-table matSort [dataSource]="projetsAnneeTableDataSource" (matSortChange)="_updateSortParams($event)" class="mat-elevation-z8">
    <!-- Id Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsDeclaration.resultsTable.id"></span>
      </th>
      <td mat-cell *matCellDef="let element" (click)="accessprojetAnnee(element)"> {{element.id}} </td>
    </ng-container>

    <!-- Campagne Column -->
    <ng-container matColumnDef="exercice">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsDeclaration.resultsTable.campagne"></span>
      </th>
      <td mat-cell *matCellDef="let element" (click)="accessprojetAnnee(element)"> {{element.tamRefExercice.libelle}} </td>
    </ng-container>

    <!-- Structure Column -->
    <ng-container matColumnDef="libelleStructure">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsDeclaration.resultsTable.structure"></span>
      </th>
      <td mat-cell *matCellDef="let element" (click)="accessprojetAnnee(element)"> {{element.structureProjetAnnee.code}} - {{element.structureProjetAnnee.libelle}} </td>
    </ng-container>

    <!-- Fiche Initiale Column -->
    <ng-container matColumnDef="statut">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsDeclaration.resultsTable.fiche_initiale"></span>
      </th>
      <td mat-cell *matCellDef="let element" (click)="accessprojetAnnee(element)"> {{getStatusFicheInitiale(element.statut)}} </td>
    </ng-container>

    <!-- Trimestre1 Column -->
    <ng-container matColumnDef="FC-Trimestre1">
      <th mat-header-cell *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsDeclaration.resultsTable.fc_Trimestre1"></span>
      </th>
      <td mat-cell *matCellDef="let element" (click)="accessprojetAnnee(element)"> {{getStatusTrimestre(element, TrimestreEnum.TRIMESTRE_1)}} </td>
    </ng-container>

    <!-- Trimestre2 Column -->
    <ng-container matColumnDef="FC-Trimestre2">
      <th mat-header-cell *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsDeclaration.resultsTable.fc_Trimestre2"></span>
      </th>
      <td mat-cell *matCellDef="let element" (click)="accessprojetAnnee(element)"> {{getStatusTrimestre(element, TrimestreEnum.TRIMESTRE_2)}} </td>
    </ng-container>

    <!-- Trimestre3 Column -->
    <ng-container matColumnDef="FC-Trimestre3">
      <th mat-header-cell *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsDeclaration.resultsTable.fc_Trimestre3"></span>
      </th>
      <td mat-cell *matCellDef="let element" (click)="accessprojetAnnee(element)"> {{getStatusTrimestre(element, TrimestreEnum.TRIMESTRE_3)}} </td>
    </ng-container>

    <!-- Trimestre4 Column -->
    <ng-container matColumnDef="FC-Trimestre4">
      <th mat-header-cell *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsDeclaration.resultsTable.fc_Trimestre4"></span>
      </th>
      <td mat-cell *matCellDef="let element" (click)="accessprojetAnnee(element)"> {{getStatusTrimestre(element, TrimestreEnum.TRIMESTRE_4)}} </td>
    </ng-container>

    <!-- Visa Marin Column -->
    <ng-container matColumnDef="AvisMarin">
      <th mat-header-cell *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsDeclaration.resultsTable.avisMarin"></span>
      </th>
      <td mat-cell *matCellDef="let element" (click)="accessprojetAnnee(element)"> {{getProjetAnneeVisaMarinStatus(element)}} </td>
    </ng-container>

    <!-- Visa Marin Column -->
    <ng-container matColumnDef="nbreDiscussionSujetsOuverts">
      <th mat-header-cell *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.mesCamps.nbreDiscussionSujetsOuverts"></span>
      </th>
      <td mat-cell *matCellDef="let element" (click)="accessprojetAnnee(element)"> {{getNombreProjetAnneeDiscussionSujetsOuverts(element)}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="_projetsAnneeDisplayedColumns"></tr>
    <tr mat-row
        ddcMouseEventManager [typeDdc]="TypeDossierEnum.PROJET_ANNEE" [idDdc]="row.id"
        *matRowDef="let row; columns: _projetsAnneeDisplayedColumns;"></tr>
  </table>
</div>
